import 'vue-final-modal/style.css';

import { createVfm } from 'vue-final-modal';

import { defineAppPlugin } from '@/main';

export default defineAppPlugin(context => {
  const vfmPlugin = createVfm();
  context.app.use(vfmPlugin);
});
